import { Button, Center, Grid, GridItem, Skeleton, Stack, Text, useBoolean } from "@chakra-ui/react"
import React, { useEffect, useState } from "react"
import { RiRestartLine } from "react-icons/ri"

import GeneratorsApi from "@shared/api/generators"
import { errorsStr } from "@shared/resourses/strings"
import CopiedButton from "@shared/ui/copied-button"

interface Uuids {
  uuid4: string[]
}

const UuidGenerator = () => {
  const [uuids, setUuids] = useState<Uuids | null>(null)
  const [errorInfo, setErrorInfo] = useState<string>("")
  const [needReload, controlNeedReload] = useBoolean(false)

  useEffect(() => {
    if (!uuids) {
      GeneratorsApi.makeUuidGeneratorHandler().then(({ result }) => {
        if (result) {
          setUuids(result)
        } else {
          setErrorInfo(errorsStr.SOMETHING_WENT_WRONG)
        }
      })
    }
  }, [uuids])

  useEffect(() => {
    if (needReload) {
      GeneratorsApi.makeUuidGeneratorHandler().then(({ result }) => {
        if (result) {
          setUuids(result)
        } else {
          setErrorInfo(errorsStr.SOMETHING_WENT_WRONG)
        }
      })
      controlNeedReload.off()
    }
  }, [needReload, controlNeedReload])

  return !uuids ? (
    <Skeleton flex={"1"} h={"10"} />
  ) : (
    <Stack>
      <Grid templateColumns={"repeat(1, 1fr)"} gap={6}>
        {errorInfo && (
          <GridItem colSpan={2}>
            <Center>
              <Text fontWeight={"bold"}>{errorInfo}</Text>
            </Center>
          </GridItem>
        )}
        <GridItem>
          <Button gap={"3"} variant="outline" onClick={controlNeedReload.on}>
            Generate <RiRestartLine />
          </Button>
        </GridItem>
        <GridItem>
          <Text color={"cyan.600"} fontWeight={"bold"}>
            UUID4
          </Text>
          <Grid templateColumns={{ md: "repeat(3, 1fr)", base: "repeat(1, 1fr)" }} gap={4}>
            {uuids.uuid4.map((value) => (
              <CopiedButton key={value} value={value} />
            ))}
          </Grid>
        </GridItem>
      </Grid>
    </Stack>
  )
}

export default UuidGenerator
